export const isFieldHidden = (field: server.dto.FormElementBehaviors): boolean => 
  field === "disabled" || field === "notVisible";